import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomerComponent } from './customer.component';
import { ListItemDetailComponent } from './components/shared/list-item/list-item-detail.component';
import { LandingPageComponent } from '@rensa/modules/customer/components/landing-page/landing-page.component';
import { RegistrationComponent } from '@rensa/modules/customer/components/registration/registration.component';
import { UnregisterComponent } from '@rensa/modules/customer/components/unregister/unregister.component';
import { KenniscafeComponent } from './components/kenniscafe/kenniscafe.component';
import { TrainingenComponent } from './components/trainingen/trainingen.component';

const routes: Routes = [
    {
        path: '',
        component: CustomerComponent,
        children: [
            {
                path: '',
                component: LandingPageComponent,
            },
            {
                path: 'trainingen',
                component: TrainingenComponent,
            },
            {
                path: 'kenniscafe',
                component: KenniscafeComponent,
            },
            {
                path: 'kenniscafe/detail/:id',
                component: ListItemDetailComponent,
            },
            {
                path: 'trainingen/detail/:id',
                component: ListItemDetailComponent,
            },
            {
                path: 'afmelden/:trainingId/:eventId/:userId',
                component: UnregisterComponent,
            },
            {
                path: ':trainingId/:eventId',
                component: RegistrationComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CustomerRoutingModule {}
